// extracted by mini-css-extract-plugin
export default {"adminDrawerViewPage":"adminEditLink_adminDrawerViewPage__5ZX1D","Edit":"adminEditLink_Edit__1iWnx"};